@if (image(); as image) {
    <img
        [ngSrc]="image.src"
        [placeholder]="image.placeholder"
        [priority]="priority()"
        fill
        alt=""
    />
} @else {
    <qpx-skeleton width="100%" height="100%" borderRadius="0" />
}
